import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DatosConfiguracionDocumentosService } from '../../services/datos-configuracion-documentos.service';
import { DatosDocumentosService } from '../../services/datos-documentos.service';
import { FormularioDocumentoService } from '../../services/formulario-documento.service';
import { FormularioValidacionesDocsService } from '../../services/formulario-validaciones-docs.service';


@Component({
  selector: 'app-configuracion-documento-datos-cif',
  templateUrl: './configuracion-documento-datos-cif.component.html',
  styleUrls: ['./configuracion-documento-datos-cif.component.css']
})
export class ConfiguracionDocumentoDatosCifComponent implements OnInit {

  cif:string = '';
  @Input() idPdf: string;
  cargando: boolean = false;
  @Output() cargandoEmitter: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(public formularioDocumentoService: FormularioDocumentoService,
              private datosDocumentosService: DatosDocumentosService,
              public datosConfiguracionDocumentosService: DatosConfiguracionDocumentosService,
              public formularioValidacionesDocsService: FormularioValidacionesDocsService) { }

  ngOnInit(): void {
    this.mostrarCif();
  }

  get cifPage(){ return this.formularioDocumentoService.formularioDocumento.controls['cifPage'] }
  get cifOrden(){ return this.formularioDocumentoService.formularioDocumento.controls['cifOrden'] }
  get cifFormulario(){ return this.formularioDocumentoService.formularioDocumento.controls['cifFormulario'] }
  get posicionCif(){ return this.formularioDocumentoService.formularioDocumento.controls['posicionCif'] }
  get idTipoDocumento(){ return this.formularioDocumentoService.formularioDocumento.controls['idTipoDocumento'] }

  async traeCif(id:string, pagina:number, orden:number): Promise<string>{
    return await this.datosDocumentosService.traeCif(id, pagina, orden).toPromise();
  }

  mostrarCif(){
    this.datosConfiguracionDocumentosService.nohayCif = false;
    const nuevaPagina = this.cifPage.value;
    const nuevoOrden = this.cifOrden.value;
    const cifGuardado = this.obtenerCifGuardado();

    if(nuevaPagina > 0 && nuevaPagina <= this.formularioDocumentoService.totalPages && nuevoOrden > 0){
      if (this.puedeUsarCifCacheado(cifGuardado, nuevaPagina, nuevoOrden)) {
        this.aplicarCifCacheado(cifGuardado);
        return;
      }

      this.cargando = true;
      this.cargandoEmitter.emit(true);
      this.traeCif(this.idPdf, nuevaPagina, nuevoOrden).then(
        value => {
          this.aplicarCifCacheado(value);
          this.persistirCifEnFormulario(value, nuevaPagina, nuevoOrden);
          this.cargandoEmitter.emit(false);
        },
        error => {
          console.error(error);
          this.cargando = false;
          this.cargandoEmitter.emit(false);
          this.datosConfiguracionDocumentosService.nohayCif = true;
          this.cif = "";
          this.persistirCifEnFormulario('', null, null);
        }
      );
    }else{
      this.cif = "";
      this.persistirCifEnFormulario('', null, null);
      this.cargandoEmitter.emit(false);
    }
  }

  borrarInputContrario(tipo:string){
    if(tipo=='pagina'){
      this.posicionCif.setValue('pagina');
      this.cifFormulario.setValue(null);
    }
    if(tipo=='formulario'){
      this.posicionCif.setValue('formulario');
      this.cifPage.setValue(null);
      this.cifOrden.setValue(null);
      this.cif='';
      this.persistirCifEnFormulario('', null, null);
      this.datosConfiguracionDocumentosService.nohayCif = false;
    }
  }

  private obtenerCifGuardado(): string {
    return (this.formularioDocumentoService.formularioDocumento.controls['cif']?.value ?? '') as string;
  }

  private puedeUsarCifCacheado(cif: string, cifPage: number, cifOrden: number): boolean {
    const form = this.formularioDocumentoService.formularioDocumento;
    return !!cif
      && form.controls['cifResueltoPage'].value === cifPage
      && form.controls['cifResueltoOrden'].value === cifOrden;
  }

  private aplicarCifCacheado(cif: string): void {
    this.cif = cif;
    this.cargando = false;
    this.datosConfiguracionDocumentosService.nohayCif = false;
  }

  private persistirCifEnFormulario(cif: string, page: number | null, orden: number | null): void {
    this.formularioDocumentoService.formularioDocumento.patchValue({
      cif,
      cifResueltoPage: page,
      cifResueltoOrden: orden,
    });
  }
}
